'use client';

import { c as _c } from "react/compiler-runtime";
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { useRef, useState } from 'react';
import type { CalendarEvent } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
import type { AdvancedMentoringProductDTO, BasicMentoringProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { H3 } from '@/frontend/design-system/_marketing/typography/Heading';
import { Button } from '@/frontend/design-system/actions/Button';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { Divider } from '@/frontend/design-system/layouts/Divider';
import { VerticalSpacer } from '@/frontend/design-system/layouts/VerticalSpacer';
import { Dialog, DialogBody } from '@/frontend/design-system/overlays/Dialog';
import { P2 } from '@/frontend/design-system/typography/Paragraph';
import { Calendar } from './Calendar';
import { CallForm } from './CallForm';
export function ScheduleAppointmentDialog(t0) {
  const $ = _c(31);
  const {
    isOpen,
    onClose,
    mentoringProduct
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedDay, setSelectedDay] = useState(t1);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const eventsRef = useRef(null);
  const formRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <H3>Umów spotkanie</H3>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <XMarkIcon className="size-4" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClose) {
    t4 = <div className="flex flex-row items-center justify-between">{t2}<Button plain={true} onClick={onClose}>{t3}</Button></div>;
    $[3] = onClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LightCard className="space-y-2 rounded-lg border-blue-700 p-4 shadow-md sm:p-6"><div className="flex items-center gap-2"><InformationCircleIcon className="size-6 shrink-0 text-algoprimary" /><H3 className="text-algoprimary">Spotkanie, które umawiasz jest bezpłatne</H3></div><P2 className="text-slate-600">Podczas niego poznasz szczegóły współpracy z mentorem i upewnisz się, czy wybrany przez Ciebie typ mentoringu jest dla Ciebie najlepszą opcją. Jeśli zdecydujesz się na mentoring po rozmowie, możesz dowolnie zmodyfikować jego typ.</P2></LightCard>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== selectedDay || $[7] !== selectedEvent) {
    t6 = <Calendar selectedDay={selectedDay} onSelectedDayChange={setSelectedDay} onSelectedEventChange={setSelectedEvent} selectedEvent={selectedEvent} eventsRef={eventsRef} formRef={formRef} />;
    $[6] = selectedDay;
    $[7] = selectedEvent;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider soft={true} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <VerticalSpacer size="content" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onClose) {
    t9 = <Button outline={true} size="xl" onClick={onClose}>Anuluj</Button>;
    $[11] = onClose;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = !selectedEvent;
  let t11;
  if ($[13] !== t10) {
    t11 = <Button size="xl" type="submit" disabled={t10}>Umów spotkanie</Button>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t9) {
    t12 = <div className="fixed bottom-10 left-0 flex w-full flex-col-reverse gap-2 justify-self-end px-10 md:static md:w-fit md:flex-row md:gap-6 md:px-0">{t9}{t11}</div>;
    $[15] = t11;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== mentoringProduct || $[19] !== onClose || $[20] !== selectedEvent || $[21] !== t12) {
    t13 = <div ref={formRef}><CallForm mentoringProduct={mentoringProduct} onClose={onClose} selectedEvent={selectedEvent}>{t8}{t12}</CallForm></div>;
    $[18] = mentoringProduct;
    $[19] = onClose;
    $[20] = selectedEvent;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t6) {
    t14 = <DialogBody className="mt-2 space-y-4 pb-26 md:pb-0">{t5}<div className="space-y-6">{t6}{t7}{t13}</div></DialogBody>;
    $[23] = t13;
    $[24] = t6;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isOpen || $[27] !== onClose || $[28] !== t14 || $[29] !== t4) {
    t15 = <Dialog open={isOpen} onClose={onClose} type="default" className="max-w-5xl rounded-md">{t4}{t14}</Dialog>;
    $[26] = isOpen;
    $[27] = onClose;
    $[28] = t14;
    $[29] = t4;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
}